@let selectedCategoryValue = selectedCategory();
@let selectedSubcategoryValue = selectedSubcategory();

@if (!selectedCategoryValue || !selectedSubcategoryValue) {
  <rt-dropdown class="dropdown">
    @if (!selectedCategoryValue && !selectedSubcategoryValue) {
      <rt-dropdown-header [fullWidthTitle]="true"> {{ header() }} </rt-dropdown-header>
    }

    @if (selectedCategoryValue && !selectedSubcategoryValue) {
      <rt-dropdown-header class="header">
        <rt-icon-button
          prefix
          (click)="$event.stopPropagation(); $event.preventDefault(); setCategory()"
          variant="plain"
          iconName="arrow-back"
          size="small"
          shape="square"
        />
        {{ placeholderCategoryTranslationMap[selectedCategoryValue].name }}
      </rt-dropdown-header>
    }

    @if (!selectedCategoryValue) {
      @for (category of categories; track trackByCategoryName($index, category)) {
        <rt-dropdown-item (mousedown)="setCategory(category, $event)" [hasChevronRight]="true">
          <div layout-vertical>
            <rt-heading variant="heading">
              {{ placeholderCategoryTranslationMap[category].name }}
            </rt-heading>
            <span
              [innerHTML]="placeholderCategoryTranslationMap[category].desc"
              class="description info-dropdown-text"
            ></span>
          </div>
        </rt-dropdown-item>
      }
    }

    @for (
      placeholder of noSubcategoriesPlaceholders().length
        ? noSubcategoriesPlaceholders()
        : noCategoryPlaceholders;
      track trackByPlaceholderName($index, placeholder)
    ) {
      <rt-dropdown-item
        [insertPlaceholder]="placeholder.id"
        [insertPlaceholderTarget]="activeTarget()!"
        [isSelected]="placeholder.id === active()?.id"
        (click)="select.emit(placeholder)"
        layout-vertical
      >
        <div layout layout-horizontal layout-space-between>
          <div layout layout-vertical>
            <rt-heading variant="heading">
              <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
              {{ withoutBrackets(placeholder.id) }}
              <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
            </rt-heading>
            <span
              [innerHTML]="
                placeholder.interpolated ? placeholder.value : placeholder.data.description
              "
              class="description info-dropdown-text"
            >
            </span>
          </div>
        </div>
      </rt-dropdown-item>
    }

    @if (selectedCategoryValue) {
      @for (subcategory of subcategories(); track subcategory) {
        <rt-dropdown-item
          (mousedown)="setSubcategory(subcategory, $event)"
          [hasChevronRight]="true"
        >
          <div layout-vertical>
            <rt-heading variant="heading">
              {{ placeholderCategoryTranslationMap[subcategory].name }}
            </rt-heading>
            <span
              [innerHTML]="placeholderCategoryTranslationMap[subcategory].desc"
              class="description info-dropdown-text"
            ></span>
          </div>
        </rt-dropdown-item>
      }
    }

    @if (selectFooterTemplate && !selectedCategoryValue) {
      <ng-template [ngTemplateOutlet]="selectFooterTemplate" />
    }
  </rt-dropdown>
}
@if (selectedCategoryValue && selectedSubcategoryValue) {
  <rt-placeholder-select-dropdown
    [placeholders]="placeholders()"
    [category]="selectedSubcategoryValue"
    [activeTarget]="activeTarget()!"
    [active]="active()"
    [showHeader]="true"
    (back)="setSubcategory()"
    (select)="setSubcategory(); select.emit($event)"
  />
}
